'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var cn = require('classnames');
var mergeRefs = require('react-merge-refs');
var hooks = require('@alfalab/hooks');
var coreComponentsLoader = require('@alfalab/core-components-loader/dist/cssm');
var styles = require('./index.module.css');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var cn__default = /*#__PURE__*/_interopDefaultLegacy(cn);
var mergeRefs__default = /*#__PURE__*/_interopDefaultLegacy(mergeRefs);
var styles__default = /*#__PURE__*/_interopDefaultLegacy(styles);

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
var __assign = function () {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s)
                if (Object.prototype.hasOwnProperty.call(s, p))
                    t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for (var p in s)
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
            t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

var Button = React__default['default'].forwardRef(function (_a, ref) {
    var _b, _c;
    var children = _a.children, _d = _a.view, view = _d === void 0 ? 'secondary' : _d, leftAddons = _a.leftAddons, rightAddons = _a.rightAddons, _e = _a.size, size = _e === void 0 ? 'm' : _e, _f = _a.block, block = _f === void 0 ? false : _f, className = _a.className, dataTestId = _a.dataTestId, href = _a.href, _g = _a.loading, loading = _g === void 0 ? false : _g, _h = _a.nowrap, nowrap = _h === void 0 ? false : _h, restProps = __rest(_a, ["children", "view", "leftAddons", "rightAddons", "size", "block", "className", "dataTestId", "href", "loading", "nowrap"]);
    var buttonRef = React.useRef(null);
    var focused = hooks.useFocus(buttonRef, 'keyboard')[0];
    var componentProps = {
        className: cn__default['default'](styles__default['default'].component, styles__default['default'][view], styles__default['default'][size], (_b = {},
            _b[styles__default['default'].focused] = focused,
            _b[styles__default['default'].block] = block,
            _b[styles__default['default'].iconOnly] = !children,
            _b[styles__default['default'].nowrap] = nowrap,
            _b[styles__default['default'].loading] = loading,
            _b), className),
        'data-test-id': dataTestId || null,
    };
    var buttonChildren = (React__default['default'].createElement(React__default['default'].Fragment, null,
        leftAddons && React__default['default'].createElement("span", { className: styles__default['default'].addons }, leftAddons),
        children && (React__default['default'].createElement("span", { className: cn__default['default'](styles__default['default'].text, (_c = {},
                _c[styles__default['default'].stretchText] = !(leftAddons || rightAddons),
                _c)) }, children)),
        loading && React__default['default'].createElement(coreComponentsLoader.Loader, { className: styles__default['default'].loader }),
        rightAddons && React__default['default'].createElement("span", { className: styles__default['default'].addons }, rightAddons)));
    if (href) {
        var target = restProps.target;
        return (React__default['default'].createElement("a", __assign({ rel: target === '_blank' ? 'noreferrer noopener' : undefined }, componentProps, restProps, { href: href, ref: mergeRefs__default['default']([buttonRef, ref]) }), buttonChildren));
    }
    var _j = restProps, disabled = _j.disabled, restButtonProps = __rest(_j, ["disabled"]);
    return (
    // eslint-disable-next-line react/button-has-type
    React__default['default'].createElement("button", __assign({}, componentProps, restButtonProps, { disabled: disabled || loading, ref: mergeRefs__default['default']([buttonRef, ref]) }), buttonChildren));
});
/**
 * Для отображения в сторибуке
 */
Button.defaultProps = {
    view: 'secondary',
    size: 'm',
    block: false,
    loading: false,
    nowrap: false,
};

exports.Button = Button;
